import { Button } from "@/components/ui/button";
import { WEBFLOW_BASE_URL } from "@/utils";
import { BaseAlert } from "./BaseAlert";

export const NoOfferAlert = () => {
  return (
    <BaseAlert type="error" title="This deal has ended">
      <div className="flex flex-col gap-2 pt-4 xl:gap-4">
        <p>
          The deal you’re looking for has expired or is no longer available.
        </p>
        <Button
          onClick={() => {
            window.location.href = WEBFLOW_BASE_URL;
          }}
          className="uppercase rounded-sm w-fit mx-auto px-14 py-6"
        >
          Submit new quote
        </Button>
      </div>
    </BaseAlert>
  );
};
